import React, { useState, useRef, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "./Calendar.scss";
// import { allMeetings } from "../../../services/teacher/schedule/Schedule";
// import { upcomingClasses } from "../../../services/teacher/dashboard/Dashboard";
import { FaEye, FaUpload } from "react-icons/fa";
// import { validateMeeting } from "../../../services/teacher/meeting/meeting";
import { toast } from "react-toastify";
import { allMeetings, validateMeeting } from "../../services/auth";
import moment from "moment/moment";
import StartTime from "./StartTimes";
const Calendar = () => {
  const navigate = useNavigate();
  const calendarRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(new Date().toDateString());
  const currentDate = new Date().toISOString().split("T")[0];
  const [selectedDate1, setSelectedDate1] = useState(currentDate);
  const [currentView, setCurrentView] = useState("timeGridWeek");
  const [currentMonth, setCurrentMonth] = useState(
    new Date().toLocaleString("default", { month: "long", year: "numeric" })
  );
  const [events, setEvents] = useState([]);
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    // const datafetch = async () => {
    //     try {
    //         const utcDate = new Date(selectedDate).toISOString();
    //         const response = await upcomingClasses({ date: utcDate });
    //         if (response && response.todaySession) {
    //             setClasses(response.todaySession);
    //         } else {
    //             setClasses([]);
    //         }
    //     } catch (error) {
    //         if (error) {
    //             setClasses([]);
    //         }
    //         // console.log(error, "response======s");
    //     }
    // };
    // if (selectedDate) {
    //     datafetch();
    // }
  }, [selectedDate]);

  // console.log(classes, "classes");

  const formatTime = (dateString) => {
    return new Date(dateString).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const goToPrev = () => {
    const calendarApi = calendarRef.current?.getApi();
    calendarApi.prev();
    const currentDate = calendarApi.getDate();
    setCurrentMonth(
      currentDate.toLocaleString("default", { month: "long", year: "numeric" })
    );
  };

  const goToNext = () => {
    const calendarApi = calendarRef.current?.getApi();
    calendarApi.next();
    const currentDate = calendarApi.getDate();
    setCurrentMonth(
      currentDate.toLocaleString("default", { month: "long", year: "numeric" })
    );
  };

  const goToToday = () => {
    const calendarApi = calendarRef.current?.getApi();
    calendarApi.today();
    const currentDate = calendarApi.getDate();
    setCurrentMonth(
      currentDate.toLocaleString("default", { month: "long", year: "numeric" })
    );
  };

  const handleMeeting = async (meetingId) => {
    try {
      let { status, token, message } = await validateMeeting({ meetingId });
      if (status === true) {
        window.open(`/hr_meeting/${token}`);
      } else if (status === false && message != "") {
        toast.error(message);
      }
    } catch (error) {
      console.log(error, "errorerror");
    }
  };

  const changeView = (view) => {
    setCurrentView(view);
    const calendarApi = calendarRef.current?.getApi();
    calendarApi.changeView(view);
    if (view === "dayGridMonth") {
      const currentDate = calendarApi.getDate();
      setCurrentMonth(
        currentDate.toLocaleString("default", {
          month: "long",
          year: "numeric",
        })
      );
    }
  };

  const getEventStatsPerDay = () => {
    const stats = {};
    const now = new Date();

    events.forEach((event) => {
      const eventDate = new Date(event.start);
      const dateStr = eventDate.toDateString();
      const isFinished = new Date(event.end) < now;

      if (!stats[dateStr]) {
        stats[dateStr] = { total: 0, finished: 0 };
      }

      stats[dateStr].total += 1;
      if (isFinished) {
        stats[dateStr].finished += 1;
      }
    });

    return stats;
  };

  const eventStatsPerDay = useMemo(() => getEventStatsPerDay(), [events]);

  const renderDayHeader = (args) => {
    const dateStr = args.date.toDateString();
    const isToday = selectedDate === dateStr;
    const stats = eventStatsPerDay[dateStr] || { total: 0, finished: 0 };
    const dayFormat = new Date(args.date);

    return (
      <>
        {currentView != "dayGridMonth" && (
          <div
            className="fc-day-header-custom me-2 mb-2"
            onClick={() => setSelectedDate(dateStr)}
            style={{
              backgroundColor: isToday ? "black" : "lightgray",
              color: isToday ? "white" : "black",
              padding: "10px",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            <div className="d-flex justify-content-between">
              <p className="mt-2 mb-0">
                {dayFormat.toLocaleString("en-US", { weekday: "short" })}
              </p>
              <p className="mb-0 day-text">{dayFormat.getDate()}</p>
            </div>
            <div
              className="task-container"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              {!isToday ? (
                <>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "2px",
                      borderRadius: "50%",
                      backgroundColor: "white",
                      border: "1px solid gray",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "30px",
                        height: "30px",
                        color: "white",
                        borderRadius: "50%",
                        backgroundColor: "lightblue",
                      }}
                    >
                      {stats.total}
                    </span>
                  </div>
                  <span style={{ color: "lightgray", fontSize: "14px" }}>
                    tasks done
                  </span>
                </>
              ) : (
                <>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "2px",
                      borderRadius: "50%",
                      backgroundColor: "black",
                      border: "1px solid black",
                    }}
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        width: "30px",
                        height: "30px",
                        color: "skyblue",
                        backgroundColor: "black",
                        fontSize: "12px",
                      }}
                    >
                      {stats.finished} / {stats.total}
                    </span>
                  </div>
                  <span style={{ color: "white", fontSize: "14px" }}>
                    tasks done
                  </span>
                </>
              )}
            </div>
          </div>
        )}
      </>
    );
  };

  // Fetch meetings and update state
  useEffect(() => {
    const fetchMeetings = async () => {
      try {
        const response = await allMeetings("HrInterview");
        if (response?.data?.data) {
          const newEvents = response?.data?.data?.map((item) => {
            return {
              title: item?.meetingName,
              start: item?.startDate,
              end: item?.endDate,
              color: "#4db6ac",
              meetingId: item?.meetingId,
              status: item?.status,
            };
          });
          setEvents(newEvents || []);
        }
      } catch (error) {
        console.error("Error fetching meetings:", error);
      }
    };
    fetchMeetings();
  }, []);

  useEffect(() => {
    const addCustomText = () => {
      setTimeout(() => {
        const axisElements = document.querySelectorAll(
          ".fc-timegrid-axis-frame"
        );

        if (axisElements.length > 0) {
          axisElements.forEach((axisElement) => {
            if (!axisElement.querySelector(".custom-gate-text")) {
              const customText = document.createElement("div");
              customText.classList.add("custom-gate-text");
              customText.textContent = "GMT +2";
              axisElement.prepend(customText);
            }
          });
        } else {
          console.log("fc-timegrid-axis-frame not found.");
        }
      }, 500);
    };
    addCustomText();

    const observer = new MutationObserver(addCustomText);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const updateNowIndicator = () => {
      const nowIndicatorDot = document.querySelector(
        ".fc-timegrid-now-indicator-arrow"
      );

      if (nowIndicatorDot) {
        const now = new Date();
        const formattedTime = now.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
        nowIndicatorDot.setAttribute("data-time", formattedTime);
      }
    };
    updateNowIndicator();

    const interval = setInterval(updateNowIndicator);

    return () => clearInterval(interval);
  }, []);

  // console.log(, "events");
  return (
    <div>
      <div className="d-block d-lg-none mobile-calender">
        <div className="mb-4 mt-4 d-flex gap-2 align-items-center">
          <span style={{ color: "#96144d", fontSize: "25px" }}>
            <i class="fa-solid fa-handshake"></i>{" "}
          </span>{" "}
          <h5> Meeting's Schedules: </h5>
        </div>

        {console.log(events, "events")}
        <div className="calender-row-show">
          {events?.map((item, index) => {
            const now = new Date();
            const start = new Date(item?.startDate);
            const end = new Date(item?.end);

            let status = "";
            if (now > end) {
              status = "Ended";
            } else if (now < start) {
              status = "Waiting";
            } else {
              status = "";
            }

            return (
              <div className="calender-cards mt-2 mb-2" key={index}>
                <div className="fw-medium fs-5">{item?.title}</div>

                {/* <div
                  className="mt-2 mb-2"
                  style={{
                    color:
                      status === "Ended"
                        ? "red"
                        : status === "Waiting"
                        ? "orange"
                        : "green",
                    fontWeight: "600",
                    fontSize: "17px",
                  }}
                >
                  {status}
                </div> */}

                <div className="mt-2">
                  <StartTime startDate={item?.start} />
                </div>

                <div className="d-flex justify-content-between mb-1">
                  <div style={{ color: "#656a82", fontSize: "14px" }}>
                    Start : {moment(item?.start).format("ll")}
                  </div>
                  <div style={{ color: "#656a82", fontSize: "14px" }}>
                    End : {moment(item?.start).format("ll")}
                  </div>
                </div>
                <div className="mt-3 mb-2">
                  <button
                    disabled={status === "Ended"}
                    style={{
                      padding: "5px 30px",
                      borderRadius: "10px",
                      background: status === "Ended" ? "red" : "#96144d",
                      color: "white",
                      fontWeight: "600",
                      border: "none",
                      cursor: status === "Ended" ? "not-allowed" : "pointer",
                    }}
                    onClick={() => handleMeeting(item?.meetingId)}
                  >
                    {item?.status}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="d-none d-lg-block">
        <div className="top-container p-4">
          <div className="calendar-container">
            <div className="calendar-toolbar">
              <h5>Calendar</h5>
              <div className="d-flex gap-3">
                <div className="fc-toolbar-left">
                  <button className="fc-button" onClick={goToPrev}>
                    &lt;
                  </button>
                  <button className="fc-button today-btn" onClick={goToToday}>
                    {currentMonth}
                  </button>
                  <button className="fc-button" onClick={goToNext}>
                    &gt;
                  </button>
                </div>
                <div className="fc-toolbar-center">
                  <button
                    className={`fc-button1 ${
                      currentView === "dayGridMonth" ? "active" : ""
                    }`}
                    onClick={() => changeView("dayGridMonth")}
                  >
                    Month
                  </button>
                  <button
                    className={`fc-button1 ${
                      currentView === "timeGridWeek" ? "active" : ""
                    }`}
                    onClick={() => changeView("timeGridWeek")}
                  >
                    Week
                  </button>
                  <button
                    className={`fc-button1 ${
                      currentView === "timeGridDay" ? "active" : ""
                    }`}
                    onClick={() => changeView("timeGridDay")}
                  >
                    Day
                  </button>
                </div>
              </div>
            </div>

            <div
              className={
                currentView === "timeGridDay"
                  ? "timeGridDay-active"
                  : "timeGridDay-inactive"
              }
            >
              <FullCalendar
                ref={calendarRef}
                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                initialView="timeGridWeek"
                events={events}
                editable={true}
                selectable={true}
                allDaySlot={false}
                height="600px"
                nowIndicator={true}
                slotDuration="01:00:00"
                slotLabelInterval="01:00"
                slotLabelFormat={{
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }}
                eventClick={(info) => {
                  if (info.event.url) {
                    window.open(info.event.url, "_blank");
                    info.jsEvent.preventDefault();
                  }
                }}
                eventDidMount={(info) => {
                  info.el.setAttribute(
                    "title",
                    `${info.event.title}\n${info.event.url}`
                  );
                }}
                eventContent={(arg) => {
                  const start = new Date(arg.event.start);
                  const end = new Date(arg.event.end);
                  const meetingId = arg?.event?.extendedProps?.meetingId;
                  return (
                    <div className="custom-event">
                      <strong>{arg.event.title}</strong>

                      <p style={{ fontSize: "12px", margin: "2px 0" }}>
                        ✅{" "}
                        {start.toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}{" "}
                        -
                        {end.toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </p>

                      <button
                        style={{
                          backgroundColor: "#0056b3",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleMeeting(meetingId)}
                      >
                        Join Now
                      </button>
                    </div>
                  );
                }}
                dayHeaderContent={renderDayHeader}
                slotEventOverlap={false}
                headerToolbar={false}
                className="calendar-content"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
